module.exports = __webpack_public_path__ + "static/media/19.49e8cde5.jpg";